import { Platform } from "react-native";
export const isWeb = "web" === Platform.OS;
export const isIos = "ios" === Platform.OS;
export const isNative = ["android", "ios"].includes(Platform.OS);
